import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";

import axios from "axios";

import Vuelidate from "vuelidate";

import BootstrapVue from "bootstrap-vue";
// import 'bootstrap/dist/css/bootstrap.css' // Imported in SCSS in src/Main.vue
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./scss/site.scss";

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

import {library} from "@fortawesome/fontawesome-svg-core";

import {
  faAdjust,
  faAmbulance,
  faArrowCircleRight,
  faArrowRight,
  faCaretDown,
  faCaretRight,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCopy,
  faDotCircle,
  faDraftingCompass,
  faEdit,
  faEnvelope,
  faExclamationTriangle,
  faFolderOpen,
  faInfoCircle,
  faLayerGroup,
  faPaste,
  faPlusCircle,
  faQuestionCircle,
  faSave,
  faSearchDollar,
  faShareAlt,
  faSync,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faWrench,
  faWindowClose
} from "@fortawesome/free-solid-svg-icons";

// import {} from '@fortawesome/pro-solid-svg-icons';
import InputPageWrapper from "@/views/components/input/InputPageWrapper.vue";
import ValidatedInputPageWrapper from "@/views/components/input/ValidatedInputPageWrapper.vue";
import {store, userStore} from "./store/store";
import router from "./router";
import App from "./App.vue";




Vue.use(Vuelidate);

Vue.use(BootstrapVue);

// Force devtools if not production
if (process.env.DEPLOYMENT_ENV !== "prod") {
  Vue.config.devtools = true;
}

/*
 FontAwesome icons
 */

library.add(
  faUser,
  faExclamationTriangle,
  faCheck,
  faCheckCircle,
  faTimesCircle,
  faDotCircle,
  faCircle,
  faInfoCircle,
  faAdjust,
  faWindowClose,
  faEdit,
  faSave,
  faCopy,
  faPaste,
  faFolderOpen,
  faShareAlt,
  faTrashAlt,
  faCaretRight,
  faCaretDown,
  faChevronRight,
  faChevronDown,
  faArrowRight,
  faEnvelope,
  faPlusCircle,
  faDraftingCompass,
  faAmbulance,
  faSync,
  faSearchDollar,
  faChartLine,
  faQuestionCircle,
  faArrowCircleRight,
  faWrench,
  faLayerGroup
);


/*
 Units display options
 */

export const imperialPrecision = 1;
export const metricPrecision = 2;

/*
 * Main API
 */

const api_url = process.env.VUE_APP_API_URL;

export const marketing_url = process.env.VUE_APP_MARKETING_URL;

export const $http = axios.create({
  // baseURL: 'http://localhost:8001/api/',
  baseURL: api_url,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFTOKEN",
});

$http.interceptors.request.use(
  (config) => {
    const {token} = userStore;
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
);


/*
 * Layered Elastic Analysis API
 */

const lea_url = process.env.VUE_APP_SOLVER_URL;
export const $httpLea = axios.create({
  baseURL: lea_url,
});


Vue.component("font-awesome-icon", FontAwesomeIcon);

/*
 These global imports are here because vue was throwing the warning "Unknown custom element: <....>" and registering
 them here instead of locally in each component got the warning to go away.
 */
// @ts-ignore
Vue.component("input-page-wrapper", InputPageWrapper);
Vue.component("InputPageWrapper", InputPageWrapper);
// @ts-ignore
Vue.component("validated-input-page-wrapper", ValidatedInputPageWrapper);
Vue.component("ValidatedInputPageWrapper", ValidatedInputPageWrapper);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
